/**
 * EULA scroll lock for the Surface Ops form.
 *
 * The agreement checkboxes (`.terms-consent`) start disabled and unlock once
 * the visitor has scrolled the `.eula` box to the bottom, or once the box is
 * shown and turns out too short to scroll. If any box is already ticked
 * (re-render after a failed submit) they're left alone, since a disabled
 * checkbox wouldn't be submitted.
 */

const consentInputs = (form) => (form ? [...form.querySelectorAll('.terms-consent input[type="checkbox"]')] : []);

const setLocked = (inputs, locked) => {
  inputs.forEach((input) => {
    if (input.disabled !== locked) {
      input.disabled = locked;
      // Lets required-fields.js re-check the form.
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
};

// clientHeight is 0 while the form (or its page) is hidden, so a hidden EULA
// never counts as read.
const isRead = (eula) => eula.clientHeight > 0
  && eula.scrollTop + eula.clientHeight >= eula.scrollHeight - 1;

const initEula = (eula) => {
  if (eula.dataset.scrollReady) {
    return;
  }
  eula.dataset.scrollReady = '1';

  const inputs = consentInputs(eula.closest('form'));
  if (!inputs.length || inputs.some((input) => input.checked)) {
    return;
  }
  setLocked(inputs, true);

  const check = () => {
    if (isRead(eula)) {
      setLocked(inputs, false);
      eula.removeEventListener('scroll', check);
      if (observer) {
        observer.disconnect();
      }
    }
  };

  eula.addEventListener('scroll', check, { passive: true });
  // Re-check when the box is shown or resized (short EULA needs no scroll).
  const observer = window.ResizeObserver ? new ResizeObserver(check) : null;
  if (observer) {
    observer.observe(eula);
  }
};

const initAll = () => {
  document.querySelectorAll('form .eula').forEach(initEula);
};

document.addEventListener('DOMContentLoaded', initAll);

if (window.jQuery) {
  // Re-run after AJAX submits / multi-page navigation re-render the form.
  window.jQuery(document).on('gform_post_render', initAll);
}
